import { render, staticRenderFns } from "./AdminTicketButton.vue?vue&type=template&id=16dfc4ac"
import script from "./AdminTicketButton.vue?vue&type=script&lang=js"
export * from "./AdminTicketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports